import axios from 'smg/axios';
import * as models from 'smg/models';
import * as template from 'smg/template';
import * as uploads from 'smg/uploads';

declare interface myWindow extends Window {
    readonly cloudFront?: string;
}
declare const window: myWindow;

declare interface uploadResp extends models.Upload {
    hasRekognition?: boolean;
    labels: {
        label: string;
        confidence: number;
    }[];
    moderationLabels: {
        label: string;
        confidence: number;
    }[];
    combinedScore?: number;
}

declare interface uploadsResp {
    uploads: uploadResp[];
}

export class Uploader extends uploads.Uploader {
    private $container: HTMLElement;
    private $thumbTemplate: HTMLTemplateElement;
    private $thumbContainer: HTMLElement;

    constructor(private $label: HTMLLabelElement, opts: uploads.UploadOptions = {}) {
        opts.thumbnails = false;
        opts.handlers = () => {
            const $thumb = template.Clone(this.$thumbTemplate).firstElementChild as HTMLElement;
            const $a = $thumb.querySelector('.uploader-thumbnail-img-link') as HTMLAnchorElement;
            const $img = $thumb.querySelector('.uploader-thumbnail-img') as HTMLImageElement;
            const $name = $thumb.querySelector('.uploader-thumbnail-name') as HTMLElement;

            const $delete = $thumb.querySelector('.uploader-thumbnail-delete') as HTMLAnchorElement;
            $delete.addEventListener('click', e => {
                e.preventDefault();

                $thumb.remove();
                this.Remove(uploadID);

                if (!this.GetUploadIDs().length) {
                    this.$label.classList.remove('uploader--has-files');
                }
            });

            let uploadID: number;

            const handlerFuncs: uploads.HandlerFuncs = {
                onSelected: (blobURL, name) => {
                    $a.href = blobURL;
                    $a.setAttribute('data-caption', name);

                    void uploads.Load($img, blobURL, name).then(success => {
                        if (!success) {
                            $thumb.classList.add('uploader-thumbnail--no-preview');
                        }
                    });

                    $name.innerText = name;

                    this.$thumbContainer.appendChild($thumb);

                    this.$label.classList.add('uploader--has-files');
                },
                onUploadCompleted: id => {
                    uploadID = id;
                    $thumb.classList.remove('uploader-thumbnail--loading');
                },
            };
            return handlerFuncs;
        };

        super($label, opts);

        this.$container = this.$label.closest('.uploader-container') as HTMLElement;
        this.$thumbTemplate = this.$container.querySelector('.uploader-thumbnail-template') as HTMLTemplateElement;
        this.$thumbContainer = this.$container.querySelector('.uploader-thumbnails') as HTMLElement;

        if (opts.uploadIDs?.length) {
            const cloudfront: string | undefined = opts.cloudfront || window.cloudFront;
            if (!cloudfront?.length) {
                throw new Error('missing cloudfront, please provide cloudfront in opts or set window.cloudfront');
            }
            void axios.get<uploadsResp>('/uploads', {
                params: {
                    'q': `id:${opts.uploadIDs.join(',')}`,
                },
            }).then(resp => {
                resp.data.uploads.forEach(u => {
                    this.AppendThumb(u.id ?? 0, `${cloudfront}/${u.key ?? ''}`, u.name ?? '');
                });
            });
        }
    }

    // TODO - this code is extremely duplicated, but I don't know how to separate it out, since the above one returns a function that returns functions
    AppendThumb(uploadID: number, blobURL: string, name: string) {
        const $thumb = template.Clone(this.$thumbTemplate).firstElementChild as HTMLElement;
        const $a = $thumb.querySelector('.uploader-thumbnail-img-link') as HTMLAnchorElement;
        const $img = $thumb.querySelector('.uploader-thumbnail-img') as HTMLImageElement;
        const $name = $thumb.querySelector('.uploader-thumbnail-name') as HTMLElement;

        const $delete = $thumb.querySelector('.uploader-thumbnail-delete') as HTMLAnchorElement;
        $delete.addEventListener('click', e => {
            e.preventDefault();

            $thumb.remove();
            this.Remove(uploadID);

            if (!this.GetUploadIDs().length) {
                this.$label.classList.remove('uploader--has-files');
            }
        });

        $a.href = blobURL;
        $a.setAttribute('data-caption', name);

        void uploads.Load($img, blobURL, name).then(success => {
            if (!success) {
                $thumb.classList.add('uploader-thumbnail--no-preview');
            }
        });

        $name.innerText = name;

        this.$thumbContainer.appendChild($thumb);

        this.$label.classList.add('uploader--has-files');
        $thumb.classList.remove('uploader-thumbnail--loading');
    }
}